import { render, staticRenderFns } from "./ItemLinhaMostragem.vue?vue&type=template&id=ebb253b4&scoped=true"
import script from "./ItemLinhaMostragem.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemLinhaMostragem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ItemLinhaMostragem.vue?vue&type=style&index=0&id=ebb253b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb253b4",
  null
  
)

export default component.exports